<template>
  <basic-container v-loading="pageLoading">
    <el-form ref="searchForm" :model="searchForm" :rules="searchFormRules" :inline="true">
      <el-form-item label="小区名称" prop="communityId" style="margin-right: 20px">
        <el-select v-model="searchForm.communityId" placeholder="请选择小区" @change="communityIdChange">
          <el-option
            v-for="item in communityList"
            :key="item.id"
            :value="item.id"
            :label="item.title"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="活动时间" prop="timeRange" style="margin-right: 20px">
        <el-date-picker
          v-model="searchForm.timeRange"
          type="daterange"
          align="right"
          unlink-panels
          :clearable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
        <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
      </el-form-item>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
    >
      <!-- menu slot -->
      <template slot="menu" slot-scope="scope">
        <el-button
          v-if="permissionList.viewBtn"
          type="text"
          icon="el-icon-view"
          size="small"
          @click.native="openViewDialog(scope.row)"
          >查看</el-button
        >
        <el-button
          v-if="permissionList.editBtn"
          type="text"
          icon="el-icon-edit"
          size="small"
          @click.native="openEditDialog(scope.row)"
          >编辑</el-button
        >
        <el-button
          v-if="permissionList.delBtn"
          type="text"
          icon="el-icon-delete"
          size="small"
          @click.native="rowDel(scope.row)"
          >删除</el-button
        >
      </template>
      <!-- menuLeft slot -->
      <template slot="menuLeft">
        <el-button
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.addBtn"
          @click="handleAddClick"
          >新增
        </el-button>
      </template>
      <!-- col -->
      <template slot="scope" slot-scope="{ row }">
        <div style="max-height: 100px; overflow: scroll">{{ row.scope }}</div>
      </template>
    </avue-crud>
    <el-dialog
      title="新增"
      :visible.sync="rulesAddDialogVisible"
      :append-to-body="true"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <RulesAddForm
        v-if="rulesAddDialogVisible"
        :communityList="communityList"
        :subjectList="subjectList"
        @close="closeAddDialog"
      />
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="rulesEditDialogVisible"
      :append-to-body="true"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <RulesEditForm
        v-if="rulesEditDialogVisible"
        :communityList="communityList"
        :subjectList="subjectList"
        :editId="editId"
        @close="closeEditDialog"
      />
    </el-dialog>
    <el-dialog
      title="查看"
      :visible.sync="rulesViewDialogVisible"
      :append-to-body="true"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <RulesViewForm
        v-if="rulesViewDialogVisible"
        :communityList="communityList"
        :subjectList="subjectList"
        :viewId.sync="viewId"
        @close="closeViewDialog"
      />
    </el-dialog>
  </basic-container>
</template>

<script>
import dayjs from 'dayjs';
import {
  getOptionNode,
  getDict,
  getList,
  remove,
  getSubjectList,
} from '@/api/v4ward/fee/preferentialrules';
import { mapGetters } from 'vuex';

import RulesAddForm from './rules-add-form';
import RulesEditForm from './rules-edit-form';
import RulesViewForm from './rules-view-form';

export default {
  components: { RulesAddForm, RulesEditForm, RulesViewForm },
  data() {
    let now = new Date();
    return {
      pageLoading: false,
      communityList: [],
      subjectList: [],
      rulesAddDialogVisible: false,
      rulesEditDialogVisible: false,
      editId: '',
      rulesViewDialogVisible: false,
      viewId: '',
      searchForm: {
        communityId: '',
        timeRange: [undefined, undefined],
        // timeRange: [new Date(1970), new Date(2030,1,1)],
      },
      searchFormRules: {},
      form: {
        itemsetId: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      selectionList: [],
      propertyList: [],
      feeItemsetList: [],
      feeItemsetList2: [],
      validFlagSelection: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
      includeShareSelection: [
        {
          label: '享受',
          value: 1,
        },
        {
          label: '包含',
          value: 0,
        },
      ],

      option: {
        height: 'auto',
        // calcHeight:'300',
        tip: false,
        border: true,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '小区名称',
            prop: 'communityName',
          },
          {
            label: '减免名称',
            prop: 'name',
          },
          {
            label: '减免范围',
            prop: 'scope',
            slot: true,
          },
          {
            label: '减免详情',
            prop: 'sceneAndDerate',
          },
          {
            label: '生效时间',
            prop: 'useTime',
          },
          {
            label: '失效时间',
            prop: 'stopTime',
          },
        ],
      },
      data: [],
      viewForm: false,
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.preferential_rules_add, true),
        viewBtn: this.vaildData(this.permission.feeitemsetpreferent_view, false),
        delBtn: this.vaildData(this.permission.feeitemsetpreferent_delete, false),
        editBtn: this.vaildData(this.permission.feeitemsetpreferent_edit, false),
      };
    },
  },
  created() {
    this.pageLoading = true;
    getOptionNode({useType:2,power:1}).then((res) => {
      this.pageLoading = false;
      this.communityList = res.data;
      if (this.communityList.length > 0) {
        this.searchForm.communityId = this.communityList[0].id;
        this.onLoad();
      }
    });
    getSubjectList().then((res) => {
      this.subjectList = res.data;
    });
  },
  methods: {
    communityIdChange(val) {
      console.log('communityIdChange=======>',val);
    },
    handleAddClick() {
      this.rulesAddDialogVisible = true;
    },
    closeAddDialog() {
      this.onLoad();
      this.rulesAddDialogVisible = false;
    },
    openEditDialog(row) {
      this.editId = row.id;
      this.rulesEditDialogVisible = true;
    },
    closeEditDialog() {
      this.onLoad();
      this.rulesEditDialogVisible = false;
    },
    openViewDialog(row) {
      this.viewId = row.id;
      this.rulesViewDialogVisible = true;
    },
    closeViewDialog() {
      this.rulesViewDialogVisible = false;
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad();
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
    handleDelete() {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad();
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        })
        .catch((err) => {
          console.log('err==>', err);
        });
    },
    beforeOpen(done, type) {
      this.rulesEditDialogVisible = true;
      done();
    },
    searchReset() {
      //let now = new Date();
      this.searchForm.timeRange = [undefined, undefined];
      this.searchForm.communityId = this.communityList[0].id;
      this.onLoad();
    },
    submitSearchForm() {
      this.page.current = 1;
      this.onLoad();
    },
    currentChange(current) {
      console.log('==>', current);
      this.page.current = current;
      this.onLoad();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad();
    },
    refreshChange() {
      this.onLoad();
    },
    onLoad() {
      this.loading = true;
      // if (this.searchForm.timeRange && this.searchForm.timeRange.length > 0) {
      //   this.searchForm.stopStartTime = dayjs(this.searchForm.timeRange[0]).format(
      //     'YYYY-MM-DD 00:00:00'
      //   );
      //   this.searchForm.stopEndTime = dayjs(this.searchForm.timeRange[1]).format(
      //     'YYYY-MM-DD 23:59:59'
      //   );
      // } else {
      //   this.searchForm.stopStartTime = dayjs().format('YYYY-MM-DD 00:00:00');
      //   this.searchForm.stopEndTime = dayjs().format('YYYY-MM-DD 23:59:59');
      // }
      this.searchForm.stopStartTime = this.searchForm.timeRange[0] ? dayjs(this.searchForm.timeRange[0]).format('YYYY-MM-DD 00:00:00') : '';
      this.searchForm.stopEndTime = this.searchForm.timeRange[1] ? dayjs(this.searchForm.timeRange[1]).format('YYYY-MM-DD 00:00:00') : '';
      const params = {
        currentPage: this.page.currentPage,
        pageSize: this.page.pageSize,
        current: this.page.current,
        communityId: this.searchForm.communityId,
        stopStartTime: this.searchForm.stopStartTime,
        stopEndTime: this.searchForm.stopEndTime,
      };
      getList(Object.assign(params)).then((res) => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records;
        // this.data.forEach(ele=>{
        //   ele.useTime = dayjs(ele.useTime).format('YYYY-MM-DD');
        //   ele.stopTime = dayjs(ele.stopTime).format('YYYY-MM-DD');
        // })
        this.loading = false;
      });
    },
  },
};
</script>
